import * as types from './constants';
import {buildFormData} from '~/utils/formdata';

export const getTableData = (query = {}, filter = {}) => ({
    types: [
        types.GET_ORDERS_LIST_REQUEST,
        types.GET_ORDERS_LIST_SUCCESS,
        types.GET_ORDERS_LIST_FAILURE,
    ],
    promise: api => {
        let form = new FormData();
        buildFormData(form, query);
        return api({
            url: `/api/v1/orders?_method=GET`,
            method: 'POST',
            body: form,
        });
    }
});

export const getTableConfiguration = (query = {}, filter = {}) => ({
    types: [
        types.GET_ORDERS_TABLE_CONFIGURATION_REQUEST,
        types.GET_ORDERS_TABLE_CONFIGURATION_SUCCESS,
        types.GET_ORDERS_TABLE_CONFIGURATION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/configure`,
            method: 'GET',
        }),
});

export const updateTableRow = (orderId, data = {}) => ({
    types: [
        types.UPDATE_ORDERS_TABLE_ROW_REQUEST,
        types.UPDATE_ORDERS_TABLE_ROW_SUCCESS,
        types.UPDATE_ORDERS_TABLE_ROW_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/row/${orderId}`,
            method: 'POST',
            body: data
        }),
});

export const deleteTableRows = (ordersId, data = {}) => ({
    types: [
        types.DELETE_ORDER_DETAILS_REQUEST,
        types.DELETE_ORDER_DETAILS_SUCCESS,
        types.DELETE_ORDER_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${ordersId}`,
            method: 'DELETE',
        }),
});

export const getOrderDetails = (orderId) => ({
    types: [
        types.GET_ORDERS_DETAILS_REQUEST,
        types.GET_ORDERS_DETAILS_SUCCESS,
        types.GET_ORDERS_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}`,
            method: 'GET',
        }),
});

export const getAllClientOrders = (orderId) => ({
    types: [
        types.GET_ALL_CLIENT_ORDERS_REQUEST,
        types.GET_ALL_CLIENT_ORDERS_SUCCESS,
        types.GET_ALL_CLIENT_ORDERS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/client-orders`,
            method: 'GET',
        }),
});

export const updateOrderDetails = (orderId, data) => ({
    types: [
        types.UPDATE_ORDER_DETAILS_REQUEST,
        types.UPDATE_ORDER_DETAILS_SUCCESS,
        types.UPDATE_ORDER_DETAILS_FAILURE,
    ],
    promise: api =>
        api({
            url: orderId ? `/api/v1/orders/${orderId}` : '/api/v1/orders',
            method: 'POST',
            body: data
        }),
});


export const updateOrderStatus = (orderId, status) => ({
    types: [
        types.UPDATE_ORDER_STATUS_REQUEST,
        types.UPDATE_ORDER_STATUS_SUCCESS,
        types.UPDATE_ORDER_STATUS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/status`,
            method: 'POST',
            body: {status}
        }),
});

export const mergeOrderProducts = (mainOrderId, ordersId) => ({
    types: [
        types.MERGE_ORDER_PRODUCTS_REQUEST,
        types.MERGE_ORDER_PRODUCTS_SUCCESS,
        types.MERGE_ORDER_PRODUCTS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${mainOrderId}/products`,
            method: 'POST',
            body: {ordersId}
        }),
});

export const exportOrders = (query = {}) => ({
    types: [
        types.EXPORT_ORDERS_REQUEST,
        types.EXPORT_ORDERS_SUCCESS,
        types.EXPORT_ORDERS_FAILURE,
    ],
    promise: api => {
        let form = new FormData();
        buildFormData(form, query);
        return api({
            url: `/api/v1/orders/export?_method=GET`,
            method: 'POST',
            body: form,
        });
    },
});

export const callClient = (orderId) => ({
    types: [
        types.CALL_CLIENT_REQUEST,
        types.CALL_CLIENT_SUCCESS,
        types.CALL_CLIENT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/call`,
            method: 'POST',
        }),
})

export const getCallUrl = (callId) => ({
    types: [
        types.GET_CALL_URL_REQUEST,
        types.GET_CALL_URL_SUCCESS,
        types.GET_CALL_URL_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/external-calls/get-call-url?call_id=${callId}`,
            method: 'GET',
        }),
});

export const updateOrderComment = (orderId, comment) => ({
    types: [
        types.UPDATE_ORDER_COMMENT_REQUEST,
        types.UPDATE_ORDER_COMMENT_SUCCESS,
        types.UPDATE_ORDER_COMMENT_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/comment`,
            method: 'POST',
            body: {comment}
        }),
});

export const attachOrderFile = (orderId, data) => ({
    types: [
        types.ATTACH_ORDER_FILE_REQUEST,
        types.ATTACH_ORDER_FILE_SUCCESS,
        types.ATTACH_ORDER_FILE_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/file`,
            method: 'POST',
            body: {...data}
        }),
});

export const getOrderBankTransactions = (orderId) => ({
    types: [
        types.GET_ALL_ORDER_BANK_TRANSACTIONS_REQUEST,
        types.GET_ALL_ORDER_BANK_TRANSACTIONS_SUCCESS,
        types.GET_ALL_ORDER_BANK_TRANSACTIONS_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/bank-transactions`,
            method: 'GET',
        }),
});

export const createOrderCost = (orderId, data) => ({
    types: [
        types.CREATE_NEW_ORDER_COST_REQUEST,
        types.CREATE_NEW_ORDER_COST_SUCCESS,
        types.CREATE_NEW_ORDER_COST_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/cost`,
            method: 'POST',
            body: data,
        }),
});

export const getOrderShortlink = (orderId, data) => ({
    types: [
        types.GET_ORDER_SHORTLINK_REQUEST,
        types.GET_ORDER_SHORTLINK_SUCCESS,
        types.GET_ORDER_SHORTLINK_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/${orderId}/shortlink`,
            method: 'GET',
        }),
});

export const getDefaultOrderData = () => ({
    types: [
        types.GET_ORDER_DEFAULT_DATA_REQUEST,
        types.GET_ORDER_DEFAULT_DATA_SUCCESS,
        types.GET_ORDER_DEFAULT_DATA_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/default-data`,
            method: 'GET',
        }),
});

export const getPriceGroupData = (priceGroupId) => ({
    types: [
        types.GET_PRICE_GROUP_DATA_REQUEST,
        types.GET_PRICE_GROUP_DATA_SUCCESS,
        types.GET_PRICE_GROUP_DATA_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/product-price-group/${priceGroupId}`,
            method: 'GET',
        }),
});

export const getCurrencyData = (currencyId) => ({
    types: [
        types.GET_CURRENCY_DATA_REQUEST,
        types.GET_CURRENCY_DATA_SUCCESS,
        types.GET_CURRENCY_DATA_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/currency/${currencyId}`,
            method: 'GET',
        }),
});

export const sendOrderAction = (orderId, messageId) => ({
    types: [
        types.SEND_ORDER_ACTION_REQUEST,
        types.SEND_ORDER_ACTION_SUCCESS,
        types.SEND_ORDER_ACTION_FAILURE,
    ],
    promise: api =>
        api({
            url: `/api/v1/orders/action/${orderId}/${messageId}`,
            method: 'POST',
        }),
});
